//@ts-nocheck
import classNames from 'classnames';

import { t } from '@web-solutions/module-localization';

import { Button, Text } from 'core/ui-elements';

import { IMAGES } from '../../images';

import classes from './style.module.scss';

interface BaseProps {
  subtitle: string;
  children: React.ReactElement;
  withFooter?: boolean;
  withButton?: boolean;
  onClick?: () => void;
}

const tKey = 'core.subscription.error_popup.decline_reasons.base';

export const Base: React.FC<BaseProps> = ({
  onClick,
  withFooter,
  subtitle,
  children,
  withButton,
}) => {
  return (
    <div className={classes.wrap}>
      <img
        className={classes.img}
        src={IMAGES.CARD.src}
        srcSet={IMAGES.CARD.srcSet}
        alt='background'
      />
      <Text className={classes.title}>{t(`${tKey}.title`)}</Text>
      <Text className={classes.subtitle}>{subtitle}</Text>
      <div className={classNames(classes.content, { [classes.withFooter]: withFooter })}>
        {children}
      </div>
      {withFooter && (
        <div className={classes.footer}>
          <Text
            className={classes.footerText}
            components={{ b: <span className={classes.highlight} /> }}
          >
            {`${tKey}.footer`}
          </Text>
        </div>
      )}
      {withButton && (
        <Button
          onClick={onClick}
          className={classes.btn}
          titleClassName={classes.btnTitle}
          title={t(`${tKey}.btn`)}
        />
      )}
    </div>
  );
};
